import styled from '@emotion/styled';

type Props = {
  size: string;
  color: string;
};

export const Dot = styled.i<Props>`
  border: ${(props) => props.size} solid ${(props) => props.color};
  border-radius: calc(${(props) => props.size} * 2);
  height: ${(props) => props.size};
  width: ${(props) => props.size};
  display: inline-block;
`;
